import customBreadCrumb from './custom-bread-crumb.vue'
export default customBreadCrumb



// WEBPACK FOOTER //
// ./src/components/main/components/header-bar/custom-bread-crumb/index.js